attachEvent('.blog-list__open-filters', 'click', (ev) => {
  ev.target.closest('.blog-list').querySelector('.blog-list__others').classList.add('is-open');
  toggleBodyScrollLock(true);
});

attachEvent('.blog-list__others-close', 'click', (ev) => {
  ev.target.closest('.blog-list__others').classList.remove('is-open');
  toggleBodyScrollLock(false);
});
